import { render, staticRenderFns } from "./changeIcon.vue?vue&type=template&id=0bfd079c&scoped=true"
import script from "./changeIcon.vue?vue&type=script&lang=js"
export * from "./changeIcon.vue?vue&type=script&lang=js"
import style0 from "./changeIcon.vue?vue&type=style&index=0&id=0bfd079c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd079c",
  null
  
)

export default component.exports